// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'circle-mixed-left';

export const Component = () => (
  <path d='M5.873 18.762C3.958 16.848 3 14.548 3 11.819c0-2.73.958-5.029 2.873-6.945C7.79 2.958 10.088 2 12.818 2c2.73 0 5.029.958 6.944 2.873 1.916 1.916 2.874 4.215 2.874 6.945 0 2.73-.958 5.029-2.873 6.944-1.916 1.916-4.215 2.874-6.945 2.874-2.73 0-5.029-.958-6.945-2.873Zm6.945-15.757c-2.442 0-4.502.862-6.226 2.539-1.724 1.724-2.586 3.831-2.586 6.274s.862 4.55 2.586 6.274c1.724 1.724 3.784 2.586 6.226 2.586V3.005Z' />
);

export const viewBox = '0 0 25 25';
